import React, {useContext, useState} from 'react';
import styles from './modal-content-batch-invite-investor.module.scss';
import {Row, Button, Spinner} from "react-bootstrap";
import {SecurityContext} from "../../../../../context/security-context";
import FileDropZone from "../../../../../components/FileDropZone";
import closeIcon from "../../../../../assets/close.svg";
import csvIcon from "../../../../../assets/csv.svg";
import UserService from "../../../../../services/user-service";
import checkIcon from "../../../../../assets/orders-table-accept.svg";
import failIcon from "../../../../../assets/orders-table-reject.svg";
import {
  BATCH_INVITE_INVESTOR_ERROR,
  BATCH_INVITE_INVESTOR_SUCCESS, INVITE_INVESTOR_INVALID_EMAIL
} from "../../../../../helpr/constants";
import {isValidEmail} from "../../../../../helpr/helper";

const BatchInviteInvestorModalContent = () => {
  const [ fileState, setFileState ] = useState();
  const [ uploadFlag, setUploadFlag ] = useState();
  const [ fileErrors, setFileErrors] = useState([]);
  const [successMessage, setSuccessMessage] = useState({msg:'', show: false});
  const [errorMessage, setErrorMessage] = useState({msg:'', show: false});
  const { securityState } = useContext(SecurityContext);
  const userService = new UserService();

  const formatDate = dt => (new Date(dt)).toISOString();

  //File Validator
  const validateBatchInviteFileContent = (contents, fileExtension) => {
    if(fileExtension !== 'csv'){
      setFileErrors(prevState => prevState.concat('File should be in csv format.'));
      return
    }
    const rows = contents.trim().split(/\n\r|\r\n|\n|\r/);
    if(rows < 2){
      setFileErrors(prevState => prevState.concat('Invalid File Format.'));
    }

    //Validate Header
    const headerContent = rows.slice(0,1);
    const headerColumns = headerContent[0].split(',')
    if(headerColumns.length < 2){
      setFileErrors(prevState => prevState.concat('Missing Header Columns (Selling Agent Name or Selling Agent Email Address.'));
    }
    else {
      const sellingAgentName = headerColumns[0].replace(',','').trim();
      if(sellingAgentName === ''){
        setFileErrors(prevState => prevState.concat('Invalid Selling Agent Name.'));
      }
      const sellingAgentEmailAddress = headerColumns[1].replace(',','').trim();
      if(!isValidEmail(sellingAgentEmailAddress)){
        setFileErrors(prevState => prevState.concat('Selling Agent Email Address is invalid or blank.'));
      }
    }
    //Validate Email Addresses
    //let addTip = false;
    const isValidEmailAddress = (value, index) => {
      const emailAddress = value.replace(',','').trim();
      if(emailAddress === '' || !isValidEmail(emailAddress)){
        //addTip = true;
        setFileErrors(prevState => prevState.concat(`Row ${index + 2} : Email Address is invalid or blank.`));
      }
    }
    const emailAddresses = rows.slice(1);
    emailAddresses.forEach(isValidEmailAddress)

    // if(addTip){
    //   setFileErrors(prevState => prevState.concat('Please remove/delete blank rows and ensure there are no empty rows at the end of the file.'))
    // }
  }
  const fileHandler = (file) => {
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      console.log('Validating Batch Invite File...')
      let contents = e.target.result;
      const fileExtension = file.name.split('.').pop().toLowerCase();
      validateBatchInviteFileContent(contents, fileExtension);
      setFileState(file);
    }
    fileReader.readAsText(file);
  }

  const renderFileDropZone = () => {
    if(fileState == null){
      return <FileDropZone setFileHandler={fileHandler}/>
    } else {
      return (
        <>
          <div>
            {
              fileErrors.map((err,index) => {
                return (<div key={index} className={styles['error-msg']}>{err}</div>)
              })
            }
          </div>
          <div className={styles['file-detail']}>
            <div className={styles['close-icon']} onClick={()=>removeFile()}>
              <img src={closeIcon}/>
            </div>
            <div className={styles['file-icon']}>
              <img src={csvIcon}/>
            </div>
            <div className={styles['details']}>
              <div>{fileState.name}</div>
              <div>{ formatDate(fileState.lastModified) }</div>
            </div>
          </div>
        </>
      )
    }
  }

  const removeFile = () => {
    setFileErrors([])
    setFileState(null);
  }

  const uploadFile = async () => {
    setUploadFlag(true);
    try {
      let result = await userService.getBatchInvitePresignedUrl(securityState['id'], securityState['applicationId'], fileState.name, fileState.type);
      await userService.uploadBatchInviteList(result['presignedUrl'], fileState);
      setUploadFlag(false);
      showSuccessMessage(BATCH_INVITE_INVESTOR_SUCCESS);
    } catch(error) {
      showErrorMessage(BATCH_INVITE_INVESTOR_ERROR);
    } finally {
      setFileState(null);
      setUploadFlag(false);
    }
  }

  const showSuccessMessage = (msg) => {
    setSuccessMessage({
      ...successMessage,
      msg,
      show: true
    });
    setTimeout(()=>setSuccessMessage({...successMessage, show: false}), 3600);
  }

  const showErrorMessage = (msg) => {
    setErrorMessage({
      ...errorMessage,
      msg,
      show: true
    });
    setTimeout(()=>setErrorMessage({...errorMessage, show: false}), 3600);
  }

  return (
    <div className={styles['content']}>
      <Row>
        {successMessage.show
          ? <div className={styles['success-msg']}>
            <img alt="Success" src={checkIcon} />{' '}{successMessage.msg}
          </div>
          : ''}
        {errorMessage.show
          ? <div className={styles['error-msg']}>
            <img alt="Fail" src={failIcon} />{' '}{errorMessage.msg}
          </div>
          : ''}
      </Row>
        <div className={styles['file-upload-area']}>
          { renderFileDropZone() }
        </div>
      <Row>
        <div className={styles['button-container']}>
          <Button className={styles['btn']} disabled={fileState == null || uploadFlag || fileErrors.length > 0} onClick={()=>uploadFile()}>
            { uploadFlag && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/> }
            Upload
          </Button>
        </div>
      </Row>
    </div>
  )
}

export default BatchInviteInvestorModalContent;
